/* eslint-disable @typescript-eslint/no-unused-vars */
import {useCallback, useState} from 'react';

import {
	AuthorizationsEnum,
	HomeEnum,
	OperationStateTypesEnum,
	SelectionFlowEnum,
	ServicesEnum,
} from 'presentation/constants';
import {useBookingFlowStepsStore} from 'presentation/modules/booking/shared/store/useBookingFlowStepsStore';
import {useIsComingFromInitialFlowStore} from 'presentation/pages/others/selection-flow/store/useIsComingFromInitialFlowStore';
import {useLocation, useNavigate} from 'react-router-dom';
import {useGetAuthScheduleQuery} from '../queries/useGetAuthScheduleQuery';
import {useAuthorizationsStore} from '../store/authorizationsStore';

export function useAuthorizations() {
	const setBusinessHours = useAuthorizationsStore(state => state.setBusinessHours);
	const setActiveBookingFlowStep = useBookingFlowStepsStore(state => state.setBookingStep);
	const {state, pathname} = useLocation();
	const navigate = useNavigate();
	const setIsComingFromInitialFlow = useIsComingFromInitialFlowStore(
		currentState => currentState.setIsComingFromInitialFlow,
	);
	const [operationScheduleState, setOperationScheduleState] = useState(
		OperationStateTypesEnum.NONE,
	);
	const [modalDescriptionState, setModalDescriptionState] = useState('');
	const IS_LOADING = operationScheduleState === OperationStateTypesEnum.SUBMITTING;
	const IS_ERROR = operationScheduleState === OperationStateTypesEnum.ERROR;
	const IS_DONE = operationScheduleState === OperationStateTypesEnum.DONE;
	const IS_UNAVAILABLE = operationScheduleState === OperationStateTypesEnum.UNAVAILABLE;

	const {refetch: refetchAuthSchedule} = useGetAuthScheduleQuery();

	const handleResetOperationState = () => {
		setOperationScheduleState(OperationStateTypesEnum.NONE);
	};

	const handleBack = useCallback(() => {
		if (state?.pathname && state?.step !== undefined) {
			setActiveBookingFlowStep(state?.step);
			navigate(`${state.pathname}`);
			return;
		}
		if (state?.includes(ServicesEnum.SERVICES)) {
			navigate(state);
			return;
		}
		navigate(HomeEnum.HOME_PAGE);
	}, [state]);

	const handleNext = useCallback(() => {
		navigate(AuthorizationsEnum.REQUEST);
	}, []);

	const handleChangeBeneficiary = useCallback(() => {
		setIsComingFromInitialFlow(true);
		navigate(SelectionFlowEnum.BENEFICIARY_SELECTION, {
			replace: true,
			state: {
				pathFrom: pathname,
			},
		});
	}, [pathname]);

	const handleChangeBeneficiaryWithoutPathFrom = useCallback(() => {
		setIsComingFromInitialFlow(true);
		navigate(SelectionFlowEnum.BENEFICIARY_SELECTION);
	}, []);

	const handleGetAuthSchedule = async () => {
		try {
			setOperationScheduleState(OperationStateTypesEnum.SUBMITTING);
			const {data: response} = await refetchAuthSchedule();

			if (response?.mensagem === null) {
				setBusinessHours(true);
				setOperationScheduleState(OperationStateTypesEnum.DONE);
				return;
			}

			setModalDescriptionState(response?.mensagem || '');
			setOperationScheduleState(OperationStateTypesEnum.UNAVAILABLE);
		} catch (error) {
			setOperationScheduleState(OperationStateTypesEnum.ERROR);
		}
	};

	return {
		handleBack,
		handleNext,
		handleChangeBeneficiary,
		handleChangeBeneficiaryWithoutPathFrom,
		handleGetAuthSchedule,
		modalDescriptionState,
		setModalDescriptionState,
		handleResetOperationState,
		IS_LOADING,
		IS_ERROR,
		IS_DONE,
		IS_UNAVAILABLE,
	};
}
